import tw from 'tailwind-styled-components'

export const TitleText  = tw.span`
not-italic
font-semibold
text-[12px]
text-[#005EB8]
`
export const SubtitleText  = tw.span`
not-italic
font-semibold
text-sm
line-height: 99.7%;
text-blue-600	
`

export const WhereItOccurred = tw.span`
text-[#474747]/80
text-[12px]
font-normal	
text-right
not-italic
tracking-tighter
`

export const ProtocolNotification  = tw.div`
text-[#474747]
text-sm
font-bold	
text-right
not-italic
tracking-tighter
mt-3
mb-4
`
export const Deadline = tw.div`
text-[#474747]/80
text-xs
font-normal	
text-right
not-italic
tracking-tighter
mt-2
`
export const EmptyNotification = tw.p`
text-[#474747CC];
not-italic
text-sm 
text-darkGray/80
font-normal
w-full
my-[20%]
mx-[50%]
`